import mixins from 'vue-typed-mixins';

import { Eフェーズ種別 } from '@/openapi/enum';

import 差異分析損益計算書 from '@/entries/user/pages/authorized/事業所/計画書/モニタリング/差異分析/損益計算書/差異分析損益計算書.vue';
import 差異分析貸借対照表 from '@/entries/user/pages/authorized/事業所/計画書/モニタリング/差異分析/貸借対照表/差異分析貸借対照表.vue';

import MoneyUnitSelect from '@/components/moneyUnitSelect/MoneyUnitSelect.vue';
import C勘定科目ListEditModeToggleButton from '@/components/勘定科目/listEdit/button/modeToggle/勘定科目ListEditModeToggleButton.vue';
import C勘定科目ListEditNewButton from '@/components/勘定科目/listEdit/button/new/勘定科目ListEditNewButton.vue';
import C勘定科目ListEditDialog from '@/components/勘定科目/listEdit/dialog/勘定科目ListEditDialog.vue';
import C計画書データ表示設定CheckBox from '@/components/計画書データ表示設定CheckBox/計画書データ表示設定CheckBox.vue';

import PlbscfKeystrokeResetMixin from '@/entries/user/mixins/PlbscfKeystrokeResetMixin';
import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 計画PlbscfMonitoringMixin from '@/entries/user/mixins/計画PlbscfMonitoringMixin';
import EventObserverMixin from '@/mixins/EventObserverMixin';
import TabsMixin from '@/mixins/TabsMixin';

import { TデータPlbscf } from '@/classes/service/AbstractPlbscfService';
import 差異分析Service, { 差異分析 } from '@/classes/service/モニタリング/差異分析Service';
import { PlbscfType } from '@/master/Plbscf';

export default mixins(
  EventObserverMixin,
  RoutesMixin,
  TabsMixin,
  PlbscfKeystrokeResetMixin,
  計画PlbscfMonitoringMixin
).extend({
  name: 'P差異分析',

  components: {
    tab0: 差異分析貸借対照表,
    tab1: 差異分析損益計算書,
    MoneyUnitSelect,
    C勘定科目ListEditNewButton,
    C勘定科目ListEditModeToggleButton,
    C勘定科目ListEditDialog,
    C計画書データ表示設定CheckBox,
  },

  data(): {
    tabTypes: PlbscfType[];
    service: 差異分析Service;
    差異分析: 差異分析;
  } {
    return {
      tabTypes: [PlbscfType.貸借対照表, PlbscfType.損益計算書],
      service: new 差異分析Service(Eフェーズ種別.モニタリングフェーズ),
      差異分析: {
        bs: {
          月次推移: {
            header: [],
            list: [],
          },
        },
        pls: [],
      },
    };
  },

  computed: {
    tデータPlbscfsToSave(): TデータPlbscf[] {
      return this.service.getTデータPlbscfs.filter((t) => t.番号 === this.モニタリング会計期間Year);
    },
  },

  watch: {
    async isEditing(): Promise<void> {
      if (!this.isEditing) return;
      await this.saveデータ(
        this.tデータPlbscfsToSave,
        this.service.getTデータ科目別計画Configs,
        Eフェーズ種別.モニタリングフェーズ
      );

      // 再load or 再計算
      if (this.reloadFlag) {
        await this.load();
      } else {
        this.差異分析 = this.service.calcAndCreate差異分析();
        this.initializeFlag();
      }
    },
    差異分析: {
      handler(): void {
        // load時は再計算せず終了
        if (this.isLoading) {
          this.isLoading = false;
          return;
        }
        // 値変更時、編集中フラグを立てる
        this.isEditing = true;
      },
      deep: true,
    },
    モニタリング会計期間(): void {
      this.差異分析 = this.service.calcAndCreate差異分析();
      this.$_reset();
    },
    eventCount(): void {
      // EventObserverMixin.eventCount を監視、一覧での勘定科目並び順変更、削除　を想定
      this.load();
    },
  },

  async created(): Promise<void> {
    await this.loadAndResetKeystroke();
  },

  methods: {
    async load(): Promise<void> {
      this.差異分析 = await this.loadAndParse(this.service);
    },
    onChange表示設定(): void {
      this.差異分析 = this.service.create差異分析();
      this.$_reset();
    },
    async loadAndResetKeystroke(): Promise<void> {
      await this.load();
      this.addKeystrokeResetCount();
    },
    $_reset(): void {
      this.initializeFlag();
      this.addKeystrokeResetCount();
    },
  },
});
